import React from "react";
import { useTranslation } from "react-i18next";
import FeatureCards from "../../components/common/FeatureCards";
import HeroSection from "../../components/common/HeroSection";
import PageShell from "../../components/common/PageShell";
import SectionHeader from "../../components/common/SectionHeader";
import ButtonGroup from "../../components/categories/ButtonGroup";
import { PAGE_HEROES } from "../../constants/pageHeroes";
import { SECTION_CONTAINER } from "../../utils/layout";

function Projects() {
  const { t } = useTranslation();

  return (
    <PageShell>
      <HeroSection {...PAGE_HEROES.projects} variant="page" />
      <div className="caf-section caf-section--light">
        <section
          className="caf-section__block caf-section__block--spaced"
          aria-labelledby="projects-features-title"
        >
          <SectionHeader
            titleId="projects-features-title"
            eyebrow={`${t("CAF")} ${t("SPORTS")}`}
            title={t("Expert & Professional")}
            subtitle={t("Always distinguished in all designs and products")}
          />
          <FeatureCards className="caf-section__cards" />
        </section>
        <section
          className="caf-section__block caf-section--elevated"
          aria-labelledby="projects-gallery-title"
        >
          <SectionHeader
            titleId="projects-gallery-title"
            eyebrow={t("Versatile Solutions")}
            title={t("Our Projects")}
            subtitle={t(
              "Discover Versatile Solutions Tailored to Meet Your Every Need",
            )}
          />
          <div className={`${SECTION_CONTAINER} pb-8`}>
            <ButtonGroup />
          </div>
        </section>
      </div>
    </PageShell>
  );
}

export default Projects;
